import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { hideSnackbar } from "../../redux/Slice/snackbar/snackbarSlice";

const SnackbarCompo = () => {
  const dispatch = useDispatch();
  const snackbar = useSelector((state) => state.root.snackbar);

  useEffect(() => {
    if (snackbar.open) {
      const opts = {
        onClose: () => dispatch(hideSnackbar()),   // reset redux when toast closes
      };

      switch (snackbar.type) {
        case "success":
          toast.success(snackbar.message, opts);
          break;
        case "error":
          toast.error(snackbar.message, opts);
          break;
        case "warning":
          toast.warn(snackbar.message, opts);
          break;
        case "info":
        default:
          toast.info(snackbar.message, opts);
          break;
      }
    }
  }, [snackbar, dispatch]);

  // ToastContainer must be rendered once; we include it right here.
  return (
    <ToastContainer
      position="top-right"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
};

export default SnackbarCompo;